var _excluded = ["as", "children", "size"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import styled from 'styled-components';
var getPadding = size => {
  var vertical = 5;
  var horizontal = 6;
  if (size === 'small') {
    vertical = 4;
    horizontal = 5;
  }
  if (size === 'large') {
    vertical = 6;
    horizontal = 7;
  }
  return "var(--spacing-".concat(vertical, ") var(--spacing-").concat(horizontal, ")");
};
var StyledCard = styled.article.withConfig({
  componentId: "CL__sc-pn4kte-0"
})(["display:block;border-radius:var(--border-radius-large);background:var(--surface-bkg-color);box-shadow:var(--box-shadow-small);", ";"], _ref => {
  var {
    size
  } = _ref;
  return "padding: ".concat(getPadding(size));
});
var Card = /*#__PURE__*/React.forwardRef((_ref2, ref) => {
  var {
      as = 'article',
      children,
      size = 'medium'
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded);
  return /*#__PURE__*/React.createElement(StyledCard, _extends({
    as: as,
    ref: ref,
    size: size
  }, props), children);
});
export default Card;